import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { createLogger } from "../utils/logger";
import enUS from "./en-US.json";
import filPH from "./fil-PH.json";
import {
  DEFAULT_LOCALE,
  detectInitialLocale,
  normalizeLocale,
  persistLocalePreference,
  SUPPORTED_LOCALES
} from "./locales";

const logger = createLogger("i18n");

let activeLocale = detectInitialLocale();

const isDev = Boolean(import.meta.env?.DEV);

void i18n.use(initReactI18next).init({
  lng: activeLocale,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  resources: {
    "en-US": { translation: enUS },
    "fil-PH": { translation: filPH }
  },
  saveMissing: isDev,
  returnNull: false,
  supportedLngs: SUPPORTED_LOCALES.map((locale) => locale.code)
});

if (isDev) {
  i18n.on("missingKey", (lngs, ns, key) => {
    // Surface missing translations during development so copy gaps are obvious.
    logger.warn("[i18n] Missing translation", { key, namespace: ns, locales: lngs });
  });
}

export function getActiveLocale(): string {
  return activeLocale;
}

export async function setActiveLocale(locale: string, persist = true): Promise<void> {
  const normalized = normalizeLocale(locale);
  if (normalized === activeLocale) {
    if (persist) {
      persistLocalePreference(normalized);
    }
    return;
  }
  activeLocale = normalized;
  await i18n.changeLanguage(normalized);
  if (persist) {
    persistLocalePreference(normalized);
  }
}

export { i18n };

export * from "./locales";
